import { render, staticRenderFns } from "./create_.vue?vue&type=template&id=556d9b52&"
import script from "./create_.vue?vue&type=script&lang=ts&"
export * from "./create_.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports